import {Disclosure} from '@headlessui/react';
import {
	ChevronDownIcon,
	ChevronUpIcon,
}                   from '@heroicons/react/20/solid';

export function TLDR({
	                     title = 'TL;DR?',
	                     children,
                     }) {
	return (<Disclosure as="div"
	                    className="my-8 bg-gradient-to-br from-teal-50 to-teal-100/75 rounded-2xl border border-teal-700"

	>
		{({open}) => (<>
		<Disclosure.Button className="w-full px-4">
			<div className="py-4 flex justify-between items-center gap-x-2 text-teal-900">
				<span className="font-medium leading-none">{title}</span>

				{open ? <ChevronUpIcon className="h-6 w-6" /> : <ChevronDownIcon className="h-6 w-6" />}
			</div>
		</Disclosure.Button>

		<Disclosure.Panel className="px-4 border-t border-teal-700">
			<div className="prose w-full max-w-full py-4">
				{children}
			</div>
		</Disclosure.Panel>
			</>)}
	</Disclosure>);
}
